module.exports = __webpack_public_path__ + "img/spruce-fall-icon.ba63cc41.png";